import type {FC} from 'react'
import {useEffect, useState} from 'react'

interface AnimatedCounterDigitProps {
  value: number
  unit: string
}

/**
 * Animated counter digit that smoothly transitions when value changes
 */
export const AnimatedCounterDigit: FC<AnimatedCounterDigitProps> = ({value, unit}) => {
  const [displayValue, setDisplayValue] = useState(value)
  const [isAnimating, setIsAnimating] = useState(false)

  // Animate when value changes
  useEffect(() => {
    if (displayValue !== value) {
      setIsAnimating(true)

      // Animate to new value
      const timeout = setTimeout(() => {
        setDisplayValue(value)
        setIsAnimating(false)
      }, 150) // Short delay for animation effect

      return () => {
        clearTimeout(timeout)
      }
    }

    return undefined
  }, [value, displayValue])

  return (
    <p
      className="z-10 font-medium leading-none text-moss-white"
      style={{fontSize: 'clamp(28px, calc(6.3vw + 4.4px), 80px)'}}
    >
      <span className={`transition-opacity duration-300 ${isAnimating ? 'opacity-70' : 'opacity-100'}`}>
        {displayValue}
      </span>
      <span className="opacity-70">{unit}</span>
    </p>
  )
}
